<template>
  <v-layout row wrap>
    <v-flex :class="classWidth">
      <v-switch
        color="primary"
        label="Auto numbering"
        :input-value="autoIncrement"
        :disabled="disableInputs"
        @change="$emit('update:autoIncrement', $event || false); $emit('changedinvoicenumber');"
      ></v-switch>
    </v-flex>
    <v-flex :class="classWidth">
      <v-layout row wrap>
        <v-flex xs4>
        <v-text-field
        name="prefix"
        label="Prefix"
        id="prefix"
        :value="autoIncrementPrefix"
        @input="$emit('update:autoIncrementPrefix', $event); $emit('changedinvoicenumber');"
        type="text"
        :disabled="!autoIncrement || disableInputs"
        placeholder=" "
        ></v-text-field>
        </v-flex>
        <v-flex xs6 offset-xs1>
        <v-text-field
        name="seed"
        :label="this.label"
        id="seed"
        :value="nextNumber"
        @input="$emit('update:nextNumber', $event); $emit('changedinvoicenumber');"
        type="text"
        :disabled="!autoIncrement || disableInputs"
        :rules='numberRules'
        placeholder=" "
        required
      ></v-text-field>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    autoIncrement: Boolean,
    nextNumber: [Number, String],
    autoIncrementPrefix: String,
    width: String,
    initial: Boolean,
    disableInputs: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      autoIncrementValue: this.autoIncrement,
      numberRules: [
        v => v.length > 0 || 'This field may not be empty',
        v => Number.isInteger(Number(v)) || 'The value must be an number',
        v => v > 0 || 'The value must be greater than zero'
      ]
    }
  },
  computed: {
    classWidth () {
      if (this.width === 'narrow') {
        return 'xs12'
      } else {
        return 'xs6'
      }
    },
    label () {
      if (this.initial) {
        return 'First number'
      } else {
        return 'Next number'
      }
    }
  }
}
</script>

<style>
</style>
